import type { AxiosInstance } from "axios";
import { USER_API } from "config";
import type { UserCatalog } from "types/user-catalog";

type ApiEnvelope<T> = {
  data: T;
};

/**
 * Supports both:
 * - useAxios({ allResponse: true }) / raw axios → response.data.data
 * - useAxios() default interceptor (returns envelope) → response.data
 */
export const fetchUserCatalog = async (axios: AxiosInstance): Promise<UserCatalog> => {
  const response = await axios.get<ApiEnvelope<UserCatalog> | UserCatalog>(USER_API.catalog);
  const body = response.data as ApiEnvelope<UserCatalog> | UserCatalog | undefined;

  if (!body) {
    throw new Error("Invalid /users/me/catalog response: missing body");
  }

  if ("data" in body && body.data && "workspaces" in body.data) {
    return body.data;
  }

  if ("workspaces" in body) {
    return body;
  }

  throw new Error("Invalid /users/me/catalog response: missing catalog");
};
